export var DECIMAL_TYPE;
(function (DECIMAL_TYPE) {
    DECIMAL_TYPE["SIMPLE"] = "SIMPLE";
    DECIMAL_TYPE["WEI"] = "WEI";
})(DECIMAL_TYPE || (DECIMAL_TYPE = {}));
